/**
 * Account API
 *
 * Endpoint: GET /api/fetch/accountDetails?portalId={portalId}
 *
 * Success response shape:
 * {
 *   status: "success",
 *   message: "Account and usage details retrieved successfully.",
 *   data: {
 *     plan: "Gold",
 *     cycle: "Monthly",
 *     status: "Active",
 *     usage: {
 *       allowed: 100,
 *       used: 0,
 *       usage: "0.00",
 *       days_until_reset: 20,
 *       cycle_end: "2026-03-26"
 *     }
 *   }
 * }
 */
import apiClient from './axiosInstance';

/**
 * Fetches the account plan and usage details for a given HubSpot portal.
 *
 * @param {number|string} portalId - HubSpot portal ID
 * @returns {Promise<{ plan: string, cycle: string, status: string, usage: object }>}
 * @throws {Error} normalized error with `.message` and `.status`
 */
export const fetchAccountDetails = async (portalId) => {
  console.log(process.env.REACT_APP_BASE_URL);
  const response = await apiClient.get(`${process.env.REACT_APP_BASE_URL}/account/accountDetails`, {
    params: { portalId },
  });

  // Guard: ensure the API reported success
  if (response.data?.status !== 'success') {
    throw new Error(
      response.data?.message || 'Failed to retrieve account details.'
    );
  }

  return response.data.data; // { plan, cycle, status, usage }
};
